import { ICard } from '../../shared/types/card';

export const initialState: ICard = {
  catalog_item: {
    img_big: [],
    img_thumb: [],
    id: 0,
    slug: '',
    title: '',
    img: '',
    price_kopecks: 0,
    updated_at: '',
    unit: '',
    manufacturer: '',
    parameters: '',
    availability: '',
    availability_count: 0,
    vendor: {
      id: 0,
      user_vendor_id: 0,
      title: '',
      phone: '',
      pavilion: '',
      floor: ''
    },
  },
  navigation: [],
  page_description: '',
  visibleReview: false,
  visibleInnerReview: false,
  loadingAddToCard: false,
  loadingAddToFavorite: false,
  loadingRemoveCard: false,
  isLoading: false,
};
